// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#subscription-panel .mt-5 {\n  margin-top: 5px;\n}", "",{"version":3,"sources":["webpack://./src/Containers/Customers/Componant/SubscriptionPanel/subscriptionPanel.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ","sourcesContent":["#subscription-panel {\n  .mt-5 {\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
